export default __webpack_public_path__ + "static/timeline-48fb042e32421c16ba79cb3eb42c0749.png";